export const scrollToBottom = (messagesEndRef: React.MutableRefObject<HTMLDivElement | null>) => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
};
